import React from 'react';
import BaseComponent from '../components/BaseComponent';
import { GetTxt, GetBookInfo } from '../common/ApiHelper';
import ProcessBar from '../components/ProcessBar';
import SkinSelect from '../components/SkinSelect';
import process from '../img/icons/process.svg';
import Aa from '../img/icons/Aa.svg';
import Am from '../img/icons/A-.svg';
import Ap from '../img/icons/A+.svg';
import back from '../img/icons/back.svg';
import night from '../img/icons/night.svg';
import day from '../img/icons/day.svg';
import download from '../img/icons/download.svg';
import APP from '../img/APP.png';
import Down from '../img/Down.png';

const maxFontSize = 6;
const defaultFontSize = '4';
const fontMap: {[key: string]: number} = {
    '0': 14,
    '1': 16,
    '2': 18,
    '3': 20,
    '4': 22,
    '5': 24,
    '6': 26,
}

const skinMap: {[key: string]: string} = {
    '0': 'page-read',
    '1': 'page-read-blue',
    '2': 'page-read-green',
    '3': 'page-read-light',
    '4': 'page-read-night'
}

class Read extends BaseComponent {
    state = {
        showIndex: 0,
        showSettings: false,
        settingsAnimating: true,
        settingsMask: false,
        showProg: 'hidden',
        showSet: 'hidden',
        fontSize: Number(defaultFontSize),
        skinIndex: 0,
        displaynum:"block"
    }
    public pageIndex = 0;
    public bookId = 0;
    public name = '';
    public hCount = 0;
    public vCount = 0;
    public offsetFontSize =0;
    public offsetLineHeight = 0;
    public contentCount = 0;
    public content: JSX.Element[][] = [];
    public codeKey = 0;
    public total = 0;
    public GetPageSize = 30;
    public isLoading = false;
    public isDone = false;
    public SettingsDiv: HTMLElement | null = null;
    public historyList: {showIndex: number, pageIndex: number}[] = [];
    constructor(props: any) {
        super(props);
        // window.addEventListener('resize', this.onReSize);
    }
    public onReSize = () => {
        window.location.reload();
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.onReSize)
    }
    componentDidMount() {

        const id = parseInt(this.GetQueryString(this.props.location.search,'id')!);
        this.bookId = id;

        //初始化主题
        const fontSize = localStorage.getItem('fontSizeIndex');
        if (fontSize !== null) {
            this.setState({fontSize: Number(fontSize)});
        }
        const night = localStorage.getItem('night');
        if (night !== null) {
            this.setState({skinIndex: 4});
        }
        else {
            const skin = localStorage.getItem('skin');
            if (skin !== null) {
                this.setState({skinIndex: Number(skin)});
            }
        }
        //\

        const emSize = fontSize === null ? fontMap[defaultFontSize] : fontMap[fontSize];
        console.log(emSize);
        let offsetFontSize = 1;
        const offsetLineHeight = 2;
        const height = document.documentElement.clientHeight;
        const width = document.documentElement.clientWidth;
        const vCount = Math.floor((height * 0.92) / (emSize * offsetLineHeight * offsetFontSize));
        const hCount = Math.floor((width * 0.93) / (emSize * offsetFontSize));

        this.hCount = hCount;
        this.vCount = vCount;
        this.offsetFontSize = offsetFontSize;
        this.offsetLineHeight = offsetLineHeight;
        this.contentCount = vCount * hCount * this.GetPageSize;

        this.InitReadHistory(this.GetTxtFunc);
    }
    public init() {
        const { fontSize } = this.state;
        this.hCount = 0;
        this.vCount = 0;
        this.offsetFontSize =0;
        this.offsetLineHeight = 0;
        this.contentCount = 0;
        this.content = [];
        this.codeKey = 0;
        this.total = 0;

        const emSize = fontMap[fontSize];
        let offsetFontSize = 1;
        const offsetLineHeight = 2;
        const height = document.documentElement.clientHeight;
        const width = document.documentElement.clientWidth;
        const vCount = Math.floor((height * 0.92) / (emSize * offsetLineHeight * offsetFontSize));
        const hCount = Math.floor((width * 0.93) / (emSize * offsetFontSize));

        this.hCount = hCount;
        this.vCount = vCount;
        this.offsetFontSize = offsetFontSize;
        this.offsetLineHeight = offsetLineHeight;
        this.contentCount = vCount * hCount * this.GetPageSize;

        this.InitReadHistory(this.GetTxtFunc);
    }
    public JSX2String = (els: JSX.Element[]): string => {
        if (els !== undefined) {
            return els.map(v => {
                return v.props.children;
            }).join('');
        }
        return '';
    }
    public GetTxtFunc = (done?: () => void, loadPage = 1) => {
        if (this.isLoading || this.isDone) return;
        this.isLoading = true;
        this.ShowToast('加载中...');
        // console.log(this.pageIndex, loadPage);
        // GetBookInfo(this.bookId, this.hCount, this.vCount, (res) => {
        //     console.log(res);
        // });
        GetTxt(this.bookId, this.contentCount * loadPage, this.pageIndex, (res) => {
            // console.log(res);
            if (res.ResultCode === -1) {
                this.isDone = true;
                this.RemoveToast();
                return;
            }
            this.total = res.Data.Total;
            this.name = res.Data.Name;
            let txt;
            const endStr = this.content[this.content.length - 1] !== undefined && this.content[this.content.length - 1].length === this.vCount ? '' :
            this.JSX2String(this.content[this.content.length - 1]);//最后一个回炉重做,如果最后一个行数等于每页行数，则不回炉重做
            if (endStr.length > 0) {//移除最后一个
                this.content = this.content.slice(0, this.content.length - 1);
                txt = this.initTxtEx(endStr + res.Data.Content, this.hCount, false);
            }
            else txt = this.initTxtEx(endStr + res.Data.Content, this.hCount, true);
            const content = this.Split(txt, this.vCount);
            // const contentIndex = this.contentLengths.findIndex(v => v.key === this.pageIndex);
            // if (contentIndex < 0) {
            //     const key = this.pageIndex;
            //     const value = content.length;
            //     this.contentLengths.push(...[{key, value}]);
            // }
            if (loadPage !== 1) {
                this.pageIndex = loadPage - 1;
            }
            // this.SaveReadHistory();

            this.content.push(...content);// = content;
            this.forceUpdate();
            this.isLoading = false;
            this.RemoveToast();
            done && done();
        }, () => {
            this.ShowToast('加载失败', 1, 5000);
            this.RemoveToast();
        })
    }
    public isChn = (str: string) => {
        const reg= new RegExp("[\x00-\xff]","g");
        return str.match(reg) !== null ? str.match(reg)!.length : 0;
    }
    public initTxtEx = (text: string, hCount: number, first: boolean) => {
        const result: JSX.Element[] = [];
        let index = 0;
        let isFirst = first; //是否首行
        text = text.replace(/\(/g,"（").replace(/\)/g,"）");
        text = text.replace(/\t/g,"\r\n");
        /**
         * 每次拿一行内容
         * 如果有换行直接结束本行
         */
        while (text.length > index) {
            let temp = text.substr(index, hCount);
            const tabIndex = temp.search(/(\r\n)|(\n)|(\r)/) + 1;
            //   console.log(tabIndex, temp);
            if (tabIndex > 0 && tabIndex < hCount) { //如果找到换行符 直接结束 换行则当前段落结束
                temp = text.substr(index, tabIndex);
                if (temp.length !== 1)  {
                    temp = temp.replace(/\r\n/g,'');
                    temp = temp.replace(/\n/g,'');
                    // result.push(
                    //     isFirst ? <code style={{textIndent: '2em'}} key={this.codeKey}>{temp}</code> 
                    //     : <code key={this.codeKey}>{temp}</code>
                    // );
                    result.push(
                        isFirst ? <p style={{textIndent: '2em'}} key={this.codeKey}>{temp}</p> 
                        : <p key={this.codeKey}>{temp}</p>
                    );
                    this.codeKey++;
                }
                index += tabIndex;
                isFirst = true;
            }
            else  {
                let nozhLen = this.isChn(temp);
                if (nozhLen > 0) { //非中文补偿，两个非中文等于一个中文
                    const t = text.substr(index + hCount, nozhLen);
                    nozhLen = nozhLen / 2;
                    // console.log('nozhLen', nozhLen);
                    const ts = t.split('');
                    // console.log(ts);
                    let temp = 0;
                    for (let j = 0;j < ts.length; j++)  {//在字符串后面取非中文长度，中文-1
                        let value = 0;
                        if (this.isChn(ts[j]) <= 0) value = 1;
                        else value = 0.5;

                        if ((temp + value) > nozhLen) break;
                        temp += value;
                    }
                    nozhLen = temp;
                }
                nozhLen = Math.floor(nozhLen); //向下取整
                // console.log(temp);
                temp = isFirst ?  text.substr(index, hCount + nozhLen - 2) : text.substr(index, hCount + nozhLen);
                temp = temp.replace(/\r\n/g,'');
                temp = temp.replace(/\n/g,'');
                // console.log(temp, index, hCount, nozhLen);
                // result.push(isFirst ? 
                //     <code key={this.codeKey} style={{textIndent: '2em'}}>
                //         {temp}
                //     </code> :
                //     <code key={this.codeKey}>{temp}</code>);
                result.push(isFirst ? 
                    <p key={this.codeKey} style={{textIndent: '2em'}}>
                        {temp}
                    </p> :
                    <p key={this.codeKey}>{temp}</p>);
                index += isFirst ? hCount + nozhLen - 2 : hCount + nozhLen;
                isFirst = false;
                this.codeKey++;
            }
        }
        return result;
    }
    public Split = (chartArr: any[], col: number) => {
        const allData = []; //用来装处理完的数组
        let currData = []; //子数组用来存分割完的数据
        //循环需要处理的数组
        for(let i = 0; i < chartArr.length; i++) {
            //将chartArr[i]添加到子数组
            currData.push(chartArr[i]);
            //console.log(i)
            if(((i + 1) % col === 0) || i === chartArr.length - 1) {
                //把currData加到allData里
                allData.push(currData);
                //在这里清空currData
                currData = [];
            }
        };
        return allData;
    }
    public touchStart: React.TouchList | undefined = undefined;
    public onTouch = (event: React.TouchEvent<HTMLDivElement>) => {
        if ('touchstart' === event.type) {
            this.touchStart = event.changedTouches;
        }
        else if ('touchend' === event.type) {
            const touchOffset = this.touchStart![0].screenX - event.changedTouches[0].screenX;
            const halfWidth = (document.documentElement.clientWidth * 0.2);
            if (touchOffset >  halfWidth) {
                this.PreOrNext('Next');
            }
            else if (touchOffset < 0 && touchOffset < -halfWidth) {
                this.PreOrNext('Pre');
            }
        }
    }
    public PreOrNext = (type: string) => {
        const { showSettings } = this.state;
        if (showSettings) {
            this.SettingsClick();
        }

        if (type === 'Pre') {
            this.setState({showIndex: this.state.showIndex - 1 < 0 ? 0 : this.state.showIndex - 1 }, this.SaveReadHistory);
        }
        else {
            // console.log(this.state.showIndex, this.content);
            if (this.state.showIndex > (this.content.length * 0.5) && !this.isDone ) {
                this.pageIndex++;
                this.GetTxtFunc(() => {
                    this.setState({showIndex: this.state.showIndex + 1 > (this.content.length - 1) ? (this.content.length - 1) : this.state.showIndex + 1 }, this.SaveReadHistory);
                });
            }
            else {
                this.setState({showIndex: this.state.showIndex + 1 > (this.content.length - 1) ? (this.content.length - 1) : this.state.showIndex + 1 }, this.SaveReadHistory);
            }
        }
    }
    /**
     * 保存阅读记录
     */
    public SaveReadHistory = () => {
        const history = {
            showIndex: this.state.showIndex,
            pageIndex: this.pageIndex
        }
        localStorage.setItem(this.bookId.toString(), JSON.stringify(history));
    }
    public GetReadHistory = () => {
        const historyItem = localStorage.getItem(this.bookId.toString());
        if (historyItem !== null) {
            return JSON.parse(historyItem) as {showIndex: number, pageIndex: number};
        }
        return null
    }
    public InitReadHistory = (done: (done?: () => void, loadPage?: number)=>void) => {
        const historyItem = localStorage.getItem(this.bookId.toString());
        if (historyItem !== null) {
            const history = JSON.parse(historyItem) as {showIndex: number, pageIndex: number};
            // this.pageIndex = history.pageIndex;
            done(()=>{
                if (history.showIndex !== 0) {
                    //默认跳转历史记录
                    this.setState({showIndex: history.showIndex});
                }
            }, history.pageIndex + 1)
        }
        else done();
    }
    public SettingsClick = () => {
        console.log('SettingsClick');
        // const { showSettings, settingsAnimating } = this.state;
        // // console.log(showSettings, settingsAnimating);
        // if (settingsAnimating) {
        //     return;
        // }
        // this.setState({settingsAnimating: true, showSettings: !showSettings, settingsMask: true});
        const { showSettings, settingsMask } = this.state;
        if (showSettings) {
            this.setState({showProg: 'hidden', showSet: 'hidden'}, ()=>{
                this.setState({showSettings: !showSettings, settingsMask: !settingsMask});
            });
        }
        else {
            this.setState({showSettings: !showSettings, settingsMask: !settingsMask});
        }
    }
    public historyClick = (v: {showIndex: number, pageIndex: number}) => {
        console.log(v);
        this.setState({showIndex: v.showIndex, pageIndex: v.pageIndex});
    }
    public back = () => {
        this.props.history.goBack();
    }
    public bottomClick = (type: 'prog' | 'set') => {
        console.log(type);
        if (type === 'prog') {
            this.setState({showProg: 'visible', showSet: 'hidden'});
        }
        else {
            this.setState({showProg: 'hidden', showSet: 'visible'});
        }
    }
    public progOnChange = (value: number) => {
        const readHistory = this.GetReadHistory();
        if (readHistory !== null) {
            const max = (readHistory.pageIndex + 1) * this.GetPageSize;
            if (max < value) {
                this.ShowToast('只能在已读范围内跳转', 1, 2000);
                return;
            }
        }
        this.setState({showIndex: parseInt(value.toFixed(0))}, this.SaveReadHistory);
    }
    public fontOnChange = (value: number) => {
        const temp = parseInt(value.toFixed(0));
        console.log(temp);
        localStorage.setItem('fontSizeIndex', temp.toFixed(0));
        this.setState({fontSize: temp}, this.init);
        // window.location.reload();
    }
    public AmClick = () => {
        const { fontSize } = this.state;
        let size = fontSize - 1;
        if (size < 0) {
            return;
        }
        this.fontOnChange(size);
    }
    public ApClick = () => {
        const { fontSize } = this.state;
        let size = fontSize + 1;
        if (size > maxFontSize) {
            return;
        }
        this.fontOnChange(size);
    }
    public skinOnChange = (val: number) => {
        const { skinIndex } = this.state;
        if (skinIndex === 4) {
            localStorage.removeItem('night');
        }
        localStorage.setItem('skin', val.toFixed());
        this.setState({skinIndex: val});
    }
    public nightClick = () => {
        const night = localStorage.getItem('night');
        if (night === null) {
            localStorage.setItem('night', '1');
            this.setState({skinIndex: 4});
        }
        else {
            localStorage.removeItem('night');
            const skin = localStorage.getItem('skin');
            if (skin !== null) {
                this.setState({skinIndex: Number(skin)});
            }
            else {
                this.setState({skinIndex: 0});
            }
        }
    }
    public boxz1Show = () => {
        this.setState({displaynum:"none"})
    }
    public DownAPP = () => {
        console.log('DownAPP');
        window.location.href = 'http://data.360guoxue.com:7771/files/app/downapp.asp';
    }
    public render() {
        const { showIndex, showSettings, settingsMask, showProg, showSet, fontSize, skinIndex,displaynum } = this.state;
        return (
            <div className={'c-box ' + skinMap[skinIndex.toFixed()]} style={{height: '100%', display: 'flex', justifyContent: 'flex-start', overflowY: 'hidden', flexDirection: 'column', alignItems: 'center'}} 
                onTouchStart={this.onTouch} onTouchMove={this.onTouch} onTouchEnd={this.onTouch}>
                {/* <div style={{position: 'absolute', left: '1em', fontSize: '0.8em', padding: '1em', color: 'rgb(102,93,79)'}}>{this.name}</div> */}
                <div className='read-book-name'>
                    <div style={{padding: '0em 0 0 2em'}}>{this.name}</div>
                    <div onClick={this.DownAPP} style={{padding: '0.2rem', zIndex: 1, display: 'none', justifyContent: 'center', alignItems: 'center', backgroundColor: '#cec9c9'}}>
                        <img style={{width: '0.5rem'}} src={download}/>
                        <span style={{fontSize: '0.4rem'}}>下载APP</span>
                    </div>
                </div>
                <div className='read-book-content' style={{fontSize: fontMap[fontSize]}}>
                    {this.content.length > 0 ? this.content[showIndex] : <span style={{textAlign: 'center'}}>加载中...</span>}
                </div>
                {/* <div style={{position: 'absolute', bottom: '0.5em', left: '2em', fontSize: '0.8em', color: 'rgb(102,93,79)'}}>{((showIndex * (this.contentCount / this.GetPageSize)) / this.total * 100).toFixed(0) + '%'}</div> */}
                <div className='read-book-prog'>
                    <div style={{padding: '0 0 0.5em 2em'}}>{((showIndex * (this.contentCount / this.GetPageSize)) / this.total * 100).toFixed(2) + '%'}</div>
                </div>
                <div style={{position: 'absolute', left: '0', width: '30%', height: '100%'}} onClick={this.PreOrNext.bind(this, 'Pre')}/>
                <div style={{position: 'absolute', right: '0', width: '30%', height: '100%'}} onClick={this.PreOrNext.bind(this, 'Next')}/>
                <div style={{position: 'absolute', width: '50%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <div style={{height: '33%', width: '100%'}} onClick={this.SettingsClick}/>
                </div>
                <div onTouchStart={this.boxz1Show} className="boxz1" style={{position:"absolute",width:"100%",height:"100%",zIndex:99,background:"rgba(0, 0, 0, .5)",display:displaynum}}>
                    <div style={{position:"fixed",top:"40%",left:"10%",borderRadius:"10px",height:"200px",width:"80%",background:"rgba(0,0,0,.4)",textAlign:"center",lineHeight:"200px",color:"white"}}>
                        请注意添加收藏，以便下次观看
                    </div>
                </div>
                {/* <div onClick={this.boxz1Show} style={{width: '90%', padding: '0 5%', color: 'white', height: '1.5rem', zIndex: 1, backgroundColor: '#00000060', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <div>
                        <img style={{width: '70%'}} src={APP}/>
                    </div>
                    <div onClick={this.DownAPP}>
                        <img style={{width: '70%', float: 'right'}} src={Down}/>
                    </div>
                     <div style={{padding: '0.1rem 0.5rem', border: 'white 0.05rem solid', borderRadius: '0.1rem'}} onClick={this.DownAPP}>
                        立即下载
                    </div> 
                </div> */}
                <div style={{width: '100%', zIndex: 1, height: '100%', position: 'fixed', visibility: settingsMask ? 'visible' : 'hidden'}}>
                    <header className='read-header read-opt-header'
                     style={{ transform: showSettings ? 'translateY(0%)' : 'translateY(-100%)', display: 'flex', alignItems: 'center'}}>
                        <div onClick={this.back} style={{textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '0.5rem', paddingLeft: '0.3rem'}}>
                            <img src={back}/>
                        </div>
                        <div style={{fontSize: '1.5em', padding: '0 0.2rem'}}>{this.name}</div>
                    </header>
                    <div style={{width: '100%', height: '100%'}} onClick={this.SettingsClick}/>
                    <div className='read-opt-bot' style={{ visibility: showProg as any, opacity: showProg === 'hidden' ? 0 : 1  }}>
                        <div style={{borderBottom: '1px solid rgba(255, 255, 255, 0.1)'}}>
                            <div id="readProgVal" className="read-prog-val">
                                <h4 className="ell">{this.name}</h4>
                                <output>{((showIndex * (this.contentCount / this.GetPageSize)) / this.total * 100).toFixed(2) + '%'}</output>
                            </div>
                        </div>
                        <ProcessBar 
                            max={(this.total / (this.contentCount / this.GetPageSize))} 
                            value={(showIndex + 1)} 
                            onChange={this.progOnChange}
                        />
                    </div>
                    <div className='read-opt-bot' style={{ visibility: showSet as any, opacity: showSet === 'hidden' ? 0 : 1  }}>
                        <div style={{borderBottom: '1px solid rgba(255, 255, 255, 0.1)', display: 'flex', 
                            justifyContent: 'space-between', alignItems: 'center', padding: '0 0.2rem'}}>
                            <img onClick={this.AmClick} src={Am} style={{width: '0.6rem', height: '0.6rem'}}/>
                            <ProcessBar 
                                max={maxFontSize} 
                                value={fontSize} 
                                onChange={this.fontOnChange}
                            />
                            <img onClick={this.ApClick} src={Ap} style={{width: '0.6rem', height: '0.6rem'}}/>
                        </div>
                        <SkinSelect onChange={this.skinOnChange} selectVal={skinIndex}/>
                    </div>
                    <footer ref={r => this.SettingsDiv = r } style={{width: '100%', height: '1.28rem', 
                        position: 'absolute', bottom: '0', background: 'rgba(0, 0, 0, 0.9)',
                        transform: showSettings ? 'translateY(0%)' : 'translateY(100%)',
                        transition: 'opacity .15s, transform .15s, visibility .15s',
                        display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', fontWeight: 'bold'}}>
                            <nav style={{display: 'flex', flexDirection: 'row', height: '100%', width: '100%', justifyContent: 'space-around', color: 'white', fontSize: '10px'}}>
                                <div onClick={this.bottomClick.bind(this, 'prog')} style={{textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                                    <img src={process} style={{height: '40%', fill: 'black'}}/>
                                    <h4>进度</h4>
                                </div>
                                <div onClick={this.bottomClick.bind(this, 'set')} style={{textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                                    <img src={Aa} style={{height: '40%'}}/>
                                    <h4>设置</h4>
                                </div>
                                <div onClick={this.nightClick} style={{textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                                    <img src={skinIndex === 4 ? day : night} style={{height: '40%'}}/>
                                    <h4>{skinIndex === 4 ? '日间' : '夜间'}</h4>
                                </div>
                            </nav>
                    </footer>
                </div>
            </div>
        );
    }
}

export default Read;
